import { PropsWithChildren, ReactNode } from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { getIsSupercellTemplate } from '../../../../utils/get-is-supercell-template';

interface PaymentElementContainerProps {
  content: ReactNode;
}

const IS_SUPERCELL_TEMPLATE = getIsSupercellTemplate();

export function PaymentElementContainer({
  children,
  content,
}: PropsWithChildren<PaymentElementContainerProps>) {
  return (
    <Stack height={'100%'}>
      <Box>{content}</Box>
      <Box pt={IS_SUPERCELL_TEMPLATE ? 1.5 : 2}>{children}</Box>
    </Stack>
  );
}
